module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Monster-Little-Devil-Web-640.b650d80c.jpg";